import LandingPageTemplateListPanel from './landingPageTemplateListPanel.container';

export default LandingPageTemplateListPanel;
